import axios from './axios';

export const apiRegisterInit = async (body) => {
  try {
    const resp = await axios.post('/register/init', body);
    return resp.data;
  } catch (e) {
    throw e.response && e.response.data ? e.response.data : e.message || e;
  }
};

export const apiRegisterVerify = async (body) => {
  try {
    const resp = await axios.post('/register/verify', body);
    return resp.data;
  } catch (e) {
    throw e.response && e.response.data ? e.response.data : e.message || e;
  }
};

export const apiRegisterCreateUser = async (body) => {
  try {
    const resp = await axios.post('/register/create-user', body);
    return resp.data;
  } catch (e) {
    throw e.response && e.response.data ? e.response.data : e.message || e;
  }
};

export const apiCheckCoupon = async (body) => {
  try {
    const resp = await axios.post('/register/check-coupon', body);
    return resp.data;
  } catch (e) {
    throw e.response && e.response.data ? e.response.data : e.message || e;
  }
};

export const apiCheckoutWithCode = async (payload) => {
  try {
    const resp = await axios.post(`/stripe/checkout-with-code`, payload);
    return resp.data;
  } catch (e) {
    throw e;
  }
};

export const apiTrackingUser = async (payload) => {
  try {
    await axios.post(`/register/tracks`, payload);
    return true;
  } catch (e) {
    throw e;
  }
};

export const apiEnableBulkscanProBeta = async (accessToken) => {
  try {
    const resp = await axios.post(
      `/register/enable-bsp-beta?accessToken=${accessToken}`
    );
    return resp.data;
  } catch (e) {
    throw e;
  }
};
